import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import useOperationalAccess from "app/hooks/useOperationalAccess";

/**
 * OPS-STAB-002 — route guard using admin permission/URI grants (visibility only).
 */
export default function OperationalRouteGuard({ moduleId, moduleIds, children }) {
  const { pathname } = useLocation();
  const { canAccessModule, canAccessPath } = useOperationalAccess();
  const requiredModules =
    Array.isArray(moduleIds) && moduleIds.length ? moduleIds : moduleId ? [moduleId] : [];

  if (requiredModules.length && !requiredModules.some((id) => canAccessModule(id))) {
    return <Navigate to="/not-authorized" replace state={{ from: pathname }} />;
  }
  if (!canAccessPath(pathname)) {
    return <Navigate to="/not-authorized" replace state={{ from: pathname }} />;
  }
  return <>{children}</>;
}

OperationalRouteGuard.propTypes = {
  moduleId: PropTypes.string,
  moduleIds: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
};
